import React, { useState, useEffect, useMemo } from 'react'
import lodash from 'lodash'
import styled from 'styled-components'

import { toast } from '../../../../1stlog-ui/src/utils'
import Dialog from '../../../../1stlog-ui/src/components/Dialog'
import Form from '../../../../1stlog-ui/src/components/Form'
import Field from '../../../../1stlog-ui/src/components/Field'
import Input from '../../../../1stlog-ui/src/components/Input'
import { required } from 'components/Field/Validation'
import useTemplateEditor from './useTemplateEditor'
import useTemplates from '../useTemplates'

const TemplateEditor = (props) => {
  const {} = props

  const [form, setForm] = useState({})

  const { reload } = useTemplates()

  const { isOpen, data, close, isLoading, save } = useTemplateEditor()

  const isEdit = !!lodash.get(data, 'id')

  const submit = async (values) => {
    try {
      const result = await save({ ...values, data })
      toast.success(i18n.t('template_was_saved', 'Vorlage wurde gespeichert.'))
      close()
      reload()
    } catch (err) {
      console.error('Failed to submit template', { err, values })
      toast.error(i18n.t('failed_to_submit_template', 'Speichern der Vorlage fehlgeschlagen'))
    }
  }

  return (
    <Dialog
      title={isEdit ? i18n.t('save_as_template', 'Als Vorlage speichern') : i18n.t('save_order_as_template', 'Auftrag als Vorlage speichern')}
      show={isOpen}
      onClose={close}
      closeButton={i18n.t('btn_cancel', 'Abbrechen')}
      submitButton={i18n.t("btn_save", "Speichern")}
      onSubmit={form.submit}
      isLoading={isLoading}
      showCloseIcon
      lg
    >
      <Form setForm={setForm} onSubmit={submit}>
        <Field name="name" label={i18n.t('name', 'Name')} validate={required}>
          <Input placeholder={i18n.t("enter_description", "Bezeichnung eingeben")} />
        </Field>
      </Form>
    </Dialog>
  )
}

export default TemplateEditor
